import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { AreasRes } from 'features/areas/types/areas.types'
import { useQuery } from 'libs/query'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchAreas = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)
	const query = getCurrentQuery()

	const {
		data: booths,
		isPending: isAreasLoading,
		isSuccess: isAreasSuccess
	} = useQuery<AreasRes>({
		queryKey: queryKeys.booths.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.areas(query)),

		enabled: !!auth.accessToken
	})

	return {
		booths,
		isAreasLoading,
		isAreasSuccess
	}
}
